import { QUOTE_CATEGORIES } from "./quoteDefaults";

const CURRENCY_SYMBOLS = {
    GBP: "£",
    CNY: "¥",
    EUR: "€",
    USD: "$",
};

export function getCurrencySymbol(currency) {
    return CURRENCY_SYMBOLS[currency] || currency;
}

export function formatMoney(amount, currency) {
    const value = Number(amount);
    if (!Number.isFinite(value)) {
        return `${getCurrencySymbol(currency)}0.00`;
    }

    const formatted = value.toLocaleString("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return `${getCurrencySymbol(currency)}${formatted}`;
}

export function calcLineSubtotal(unitPrice, quantity) {
    const price = parseFloat(unitPrice);
    const qty = parseFloat(quantity);

    if (!Number.isFinite(price) || !Number.isFinite(qty) || price < 0 || qty < 0) {
        return 0;
    }

    return price * qty;
}

export function formatQuantity(quantity) {
    const value = parseFloat(quantity);
    if (!Number.isFinite(value)) {
        return "0";
    }

    return Number.isInteger(value) ? String(value) : String(value);
}

export function formatQuoteDate(date) {
    if (!date) {
        return "";
    }

    return date.format("YYYY.MM.DD");
}

export function countActiveLines(categories) {
    return QUOTE_CATEGORIES.reduce((sum, key) => {
        const items = categories[key] || [];
        const active = items.filter((line) => String(line.name || "").trim());
        return sum + active.length;
    }, 0);
}

export function buildQuoteDisplay(formState) {
    const categories = QUOTE_CATEGORIES.map((key) => {
        const items = (formState.categories[key] || [])
            .filter((line) => String(line.name || "").trim())
            .map((line) => ({
                ...line,
                subtotal: calcLineSubtotal(line.unitPrice, line.quantity),
            }));

        const subtotal = items.reduce((sum, item) => sum + item.subtotal, 0);

        return { key, items, subtotal };
    }).filter((category) => category.items.length > 0);

    const grandTotal = categories.reduce((sum, category) => sum + category.subtotal, 0);
    const totalLines = categories.reduce((sum, category) => sum + category.items.length, 0);
    const globalNotes = (formState.globalNotes || [])
        .map((note) => String(note || "").trim())
        .filter(Boolean);
    const projectName = String(formState.projectName || "").trim();

    return {
        projectName,
        quoteDateLabel: formState.quoteDate ? formatQuoteDate(formState.quoteDate) : "",
        validUntilLabel: formState.validUntil ? formatQuoteDate(formState.validUntil) : "",
        currency: formState.currency,
        portfolioUrl: String(formState.portfolioUrl || "").trim(),
        hideSubitemPrices: Boolean(formState.hideSubitemPrices),
        categories,
        grandTotal,
        totalLines,
        globalNotes,
    };
}

export function validateQuoteForm(formState, t) {
    const projectName = String(formState.projectName || "").trim();
    if (!projectName) {
        return t("quote.validation.projectNameRequired");
    }

    const portfolioUrl = String(formState.portfolioUrl || "").trim();
    if (portfolioUrl) {
        try {
            const parsed = new URL(portfolioUrl);
            if (!["http:", "https:"].includes(parsed.protocol)) {
                return t("quote.validation.portfolioUrlInvalid");
            }
        } catch {
            return t("quote.validation.portfolioUrlInvalid");
        }
    }

    return "";
}
